import { render } from "./BaseBarChart.vue?vue&type=template&id=b2323f94"
import script from "./BaseBarChart.vue?vue&type=script&lang=js"
export * from "./BaseBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/charts/BaseBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b2323f94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b2323f94', __exports__)) {
    api.reload('b2323f94', __exports__)
  }
  
  module.hot.accept("./BaseBarChart.vue?vue&type=template&id=b2323f94", () => {
    api.rerender('b2323f94', render)
  })

}


export default __exports__